module.exports = __webpack_public_path__ + "static/media/mouse-alt.355b6da6.svg";